export default {
  radiology: "R",
  medicalAdmin: "M",
  admin: "A",
  technician: `T`,
};
